import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";

export const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [, setError] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRevealed, setIsRevealed] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsRevealed(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsLoading(true);

    fetch("https://formcarry.com/s/BNM2SsM78wm", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name, email, message }),
    })
      .then((response) => response.json())
      .then((response) => {
        setIsLoading(false);
        if (response.code === 200) {
          setShowNotification(true);
          setName("");
          setEmail("");
          setMessage("");
          setTimeout(() => setShowNotification(false), 5000);
        } else {
          setError(response.message);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error.message ? error.message : error);
      });
  };

  return (
    <section className="contact" id="connect" ref={sectionRef}>
      {/* Success Notification */}
      {showNotification && (
        <div className="contact-notification">
          <div className="contact-notification-inner">
            <div className="contact-notification-icon">✓</div>
            <div className="contact-notification-text">
              <h4>Message Sent!</h4>
              <p>Thank you for reaching out. I'll get back to you soon!</p>
            </div>
            <button className="contact-notification-close" onClick={() => setShowNotification(false)}>×</button>
          </div>
        </div>
      )}

      <Container>
        <div className={`reveal ${isRevealed ? 'revealed' : ''}`}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <div className="section-tag" style={{ justifyContent: 'center' }}>
              <span className="tag-dot"></span>
              Contact
            </div>
            <h2 className="section-title">
              Get In <span className="gradient-text">Touch</span>
            </h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              Feel free to reach out for any inquiries or collaboration opportunities!
            </p>
          </div>

          <Row className="align-items-center" style={{ rowGap: '40px' }}>
            <Col size={12} md={6}>
              <div className="contact-img-wrapper">
                <img src={contactImg} alt="Contact" className="contact-illustration" />
              </div>
            </Col>
            <Col size={12} md={6}>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    placeholder="Your name"
                    className="form-input"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    placeholder="Your email address"
                    className="form-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Message</label>
                  <textarea
                    rows={5}
                    placeholder="Your message..."
                    className="form-input form-textarea"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn-primary-glow"
                  disabled={isLoading}
                  style={{
                    width: '100%',
                    padding: '16px 32px',
                    border: 'none',
                    cursor: isLoading ? 'not-allowed' : 'pointer',
                    opacity: isLoading ? 0.7 : 1,
                  }}
                >
                  {isLoading ? (
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                      <span className="btn-spinner" />
                      Sending...
                    </span>
                  ) : (
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                      Send Message
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="22" y1="2" x2="11" y2="13" />
                        <polygon points="22 2 15 22 11 13 2 9 22 2" />
                      </svg>
                    </span>
                  )}
                </button>

                <div className="contact-divider">
                  <span className="contact-divider-line"></span>
                  <span className="contact-divider-text">or</span>
                  <span className="contact-divider-line"></span>
                </div>

                <a
                  href="https://wa.me/94760673035"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-whatsapp"
                  id="whatsapp-contact-btn"
                >
                  <svg viewBox="0 0 175.216 175.552" width="22" height="22">
                    <defs>
                      <linearGradient id="wa-gradient" x1="85.915" x2="86.535" y1="32.567" y2="137.092" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stopColor="#57d163"/>
                        <stop offset="1" stopColor="#23b33a"/>
                      </linearGradient>
                    </defs>
                    <path d="M87.184 14.2A73.68 73.68 0 0 0 14.4 87.6a73.07 73.07 0 0 0 10.6 37.7L14 162.4l38.2-10.8a73.2 73.2 0 0 0 35 8.9 73.68 73.68 0 0 0 0-147.36zm0 134.8a61.09 61.09 0 0 1-31.2-8.5l-2.2-1.3-22.7 6.4 6-21.9-1.5-2.4a60.87 60.87 0 0 1-9.4-32.6A61.14 61.14 0 0 1 87.4 27.8a61.14 61.14 0 0 1-.2 121.2z" fill="#fff"/>
                    <path d="M127.4 103.5c-2.2-1.1-12.9-6.4-14.9-7.1s-3.5-1.1-4.9 1.1-5.7 7.1-6.9 8.5-2.5 1.6-4.7.5a59.07 59.07 0 0 1-17.4-10.7 65.08 65.08 0 0 1-12-15c-1.3-2.2-.1-3.3 1-4.4s2.2-2.5 3.3-3.8a14.7 14.7 0 0 0 2.2-3.6 4 4 0 0 0-.2-3.8c-.5-1.1-4.9-11.8-6.7-16.2s-3.5-3.7-4.9-3.7h-4.1a8 8 0 0 0-5.8 2.7 24.2 24.2 0 0 0-7.6 18c0 10.6 7.7 20.9 8.8 22.3s15.2 23.2 36.8 32.5a124.7 124.7 0 0 0 12.3 4.5 29.6 29.6 0 0 0 13.6.9c4.1-.6 12.9-5.3 14.7-10.4s1.8-9.5 1.3-10.4-1.8-1.5-4-2.5z" fill="#fff"/>
                  </svg>
                  <span>Chat on WhatsApp</span>
                </a>
              </form>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};
